import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("auth failed");
        const user = await res.json();
        navigate("/admin/enquiries", { state: { user }, replace: true });
      } catch {
        navigate("/admin/login?error=access", { replace: true });
      }
    })();
  }, [location, navigate]);

  return null;
};

export default AuthCallback;
